import { Component, Inject, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ClientesService } from 'app/services/clientes.service';
import { ComprobantesService } from 'app/services/comprobantes.service';

@Component({
  selector: 'app-dialog-comprobantes',
  templateUrl: './dialog-comprobantes.component.html',
  styleUrls: ['./dialog-comprobantes.component.css']
})
export class DialogComprobantesComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['comprobante', 'cuotas', 'importe'];
  idCliente;
  clienteData: any = null;

  // Propiedades para estados de carga
  cargando = false;
  errorCarga = '';

  comprobantes: any[] = [];

  constructor( 
    public dialogRef: MatDialogRef<DialogComprobantesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clienteService: ClientesService,
    private comprobantesService: ComprobantesService
  ){
    this.idCliente = data.cliente;
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.getClienteData();
    this.getComprobantesACuentaByClientes();
  }

  ngAfterViewInit() {
    // Aseguramos que el dataSource tenga paginador y ordenamiento
    setTimeout(() => {
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
    });
  }

  getClienteData() {
    if (this.idCliente) {
      this.clienteService.getClienteById(this.idCliente).subscribe(
        res => {
          this.clienteData = res;
          // Si en los datos se incluye un título para el diálogo, lo utilizamos
          if (this.data && this.data.title) {
            document.querySelector('h3').textContent = this.data.title;
          } else {
            // De lo contrario usamos el tipo de cliente para el título
            const tipoCliente = this.clienteData?.type === 'cliente' ? 'CLIENTE' : 'PROVEEDOR';
            document.querySelector('h3').textContent = `COMPROBANTES PENDIENTES - ${tipoCliente}`;
          }
        },
        err => {
          console.error('Error al cargar datos del cliente:', err);
        }
      );
    }
  }

  getComprobantesACuentaByClientes() {
    // Verificamos que exista un ID de cliente
    if (!this.idCliente) {
      this.errorCarga = 'No se ha especificado un cliente';
      console.error(this.errorCarga);
      return;
    }
    
    // Activar indicador de carga
    this.cargando = true;
    this.errorCarga = '';
    
    // Usamos el servicio para obtener los comprobantes del cliente
    this.comprobantesService.getComprobanteByRecibo(this.idCliente).subscribe(
      (response) => {
        // Log completo para depuración
        console.log('Respuesta completa de API:', response);
        
        // Transformamos los datos recibidos al formato que necesitamos
        if (Array.isArray(response.data)) {
          this.comprobantes = response.data.map(comp => {
            // Verificamos que cada propiedad exista antes de intentar usarla
            console.log('Procesando comprobante:', comp);
            
            // Comprobaciones de seguridad para evitar errores
            const code = comp.voucherType?.code || 'SIN';
            const number = comp.header?.number ? comp.header.number.toString().padStart(8, '0') : '00000000';
            const numero = `${code}-${number}`;
            
            // Manejo adecuado para el campo detail que puede ser array u objeto
            let installment = '1';
            if (Array.isArray(comp.detail)) {
              // Si es un array, tomamos el primer elemento
              if (comp.detail.length > 0) {
                installment = comp.detail[0]?.installment || '1';
              }
            } else if (comp.detail) {
              // Si es un objeto, accedemos directamente
              installment = comp.detail.installment || '1';
            }
            
            return {
              id: comp.id || 0,
              numero: numero,
              cuota: installment,
              vto: comp.header?.expirationDate || new Date().toISOString().split('T')[0],
              importe: comp.totalAmount || 0,
              fechaEmision: comp.header?.dateFrom || new Date().toISOString().split('T')[0]
            };
          });
        } else {
          console.log('La respuesta no es un array:', response);
          this.comprobantes = [];
        }
        
        // Si no hay comprobantes, mostramos un mensaje o dejamos un array vacío
        if (this.comprobantes.length === 0) {
          console.log('No se encontraron comprobantes pendientes para este cliente');
        } else {
          console.log('Comprobantes procesados:', this.comprobantes);
        }
        
        // Actualizamos el dataSource (asegurando que sea un nuevo objeto)
        this.dataSource = new MatTableDataSource(this.comprobantes);
        
        // Aseguramos que se apliquen el paginador y el ordenamiento
        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }
        if (this.sort) {
          this.dataSource.sort = this.sort;
        }
      },
      (error) => {
        console.error('Error al obtener los comprobantes del cliente:', error);
        this.errorCarga = 'Error al cargar los comprobantes. Intente nuevamente.';
        
        // En caso de error, podríamos mostrar datos de ejemplo
        // o simplemente dejar la lista vacía
        this.comprobantes = [];
        this.dataSource = new MatTableDataSource(this.comprobantes);
      }
    ).add(() => {
      // Desactivar el indicador de carga al finalizar
      this.cargando = false;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  selectComprobante(indice) {
    if (indice < 0 || indice >= this.comprobantes.length) {
      console.error('Índice de comprobante inválido:', indice);
      return;
    }
    
    const comprobanteSeleccionado = this.comprobantes[indice];
    console.log('Comprobante seleccionado:', comprobanteSeleccionado);
    
    if (!comprobanteSeleccionado) {
      console.error('No se pudo seleccionar el comprobante en el índice:', indice);
      return;
    }
    
    // Asegúrate de que el comprobante tenga todos los datos necesarios
    const comprobante = {
      id: comprobanteSeleccionado.id || null,
      numero: comprobanteSeleccionado.numero || 'Sin número',
      cuota: comprobanteSeleccionado.cuota || '1',
      importe: comprobanteSeleccionado.importe || 0,
      vto: comprobanteSeleccionado.vto || new Date().toISOString().split('T')[0],
      fechaEmision: comprobanteSeleccionado.fechaEmision || comprobanteSeleccionado.vto || new Date().toISOString().split('T')[0]
    };
    
    this.dialogRef.close(comprobante);
  }

  salir() {
    this.dialogRef.close();
  }
}
